/**
 * Utilitaires pour la gestion des erreurs API
 */

/**
 * Extrait le message d'erreur d'une réponse d'erreur Axios
 * Le backend renvoie directement le message d'erreur dans data (string), pas dans data.message
 *
 * @param error - L'objet erreur (peut être une erreur Axios ou une Error standard)
 * @param defaultMessage - Message par défaut si aucun message n'est trouvé
 * @returns Le message d'erreur formaté
 */
export const extractErrorMessage = (error: any, defaultMessage: string = 'Une erreur est survenue'): string => {
  if (!error) {
    return defaultMessage;
  }

  // Cas 1: Erreur Axios avec response (erreur du serveur)
  if (error.response?.data) {
    // Le backend renvoie directement une string dans data
    if (typeof error.response.data === 'string') {
      // Filtrer les messages trop techniques pour l'utilisateur
      const data = error.response.data.trim();
      if (data && data.length > 0) {
        return data;
      }
    }

    // Fallback pour un éventuel format objet avec message
    if (error.response.data.message) {
      return error.response.data.message;
    }

    // Fallback pour un éventuel format objet avec error
    if (error.response.data.error) {
      return error.response.data.error;
    }
  }

  // Cas 2: Erreur Axios sans response (problème réseau, timeout, etc.)
  if (error.request && !error.response) {
    return 'Impossible de contacter le serveur. Vérifiez votre connexion internet.';
  }

  // Cas 3: Error standard JavaScript avec message
  if (error.message) {
    // Éviter les messages techniques d'Axios
    if (!error.message.includes('Network Error') &&
        !error.message.includes('timeout') &&
        !error.message.includes('ERR_')) {
      return error.message;
    }

    if (error.message.includes('Network Error') || error.message.includes('ERR_NETWORK')) {
      return 'Problème de connexion réseau. Vérifiez votre connexion internet.';
    }

    if (error.message.includes('timeout')) {
      return 'La requête a expiré. Veuillez réessayer.';
    }
  }

  // Cas 4: Message par défaut
  return defaultMessage;
};
